var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-component"},[_c('input',{attrs:{"id":"upload-button","type":"file","hidden":"","accept":_vm.accept},on:{"change":_vm.checkFile}}),_c('label',{staticClass:"upload",attrs:{"for":"upload-button"}},[_c('CloudIcon',{staticClass:"cloud-icon"}),_c('span',[_vm._v(_vm._s(_vm.$t('Account.Photo.Upload')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }